import { render, staticRenderFns } from "./FireclawsDru.vue?vue&type=template&id=6c3c1450"
import script from "./FireclawsDru.vue?vue&type=script&lang=js"
export * from "./FireclawsDru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports